// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__AQfyD","location_link":"_styles_location_link__piGaM","link":"_styles_link__7CqfQ"};